
import Vue from "vue";
import AppCodaUpload from "./CodaUpload.vue";
import AppCodaPreview from "./CodaPreview.vue";
import { Bank, BankType } from "@/models/base";
import { ICodaImportResult } from "@/services/coda-service";
import { BankService } from "@/services/bank-service";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import AppMissingModuleModal from "@/components/common/MissingModuleModal.vue";
import { printHumanFloat } from "@/utils/pretty-print";
import { UpgradeService } from "@/services/upgrade-service";

export default Vue.extend({
	data() {
		return {
			step: 1,
			banks: [] as Bank[],
			bankTypes: [] as BankType[],
			selectedBank: null as BankType | null,
			beginBalance: 0,
			endBalance: 0,
			accountNumber: "",
			bankId: 1
		};
	},
	computed: {
		hasModule(): boolean {
			return AuthService.hasModule(this.requiredModuleId);
		},
		requiredModuleId(): number {
			return MODULE.LINK_MET_ISABEL;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		/* eslint-disable-next-line max-lines-per-function */
		async onResult(event: ICodaImportResult, bankId: number) {

			this.selectedBank = this.bankTypes.filter((b) => b.ID == bankId)[0];

			if (event.Banks.length == 0) {
				await this.$wf.dialog(this.$ct("coda-has-no-records"), this.$ct("common.ok"), this.$ct("common.warning"), "warning");
				return;
			}

			this.beginBalance = event.BeginBalance;
			this.endBalance = event.EndBalance;
			this.accountNumber = event.AccountNumber;
			this.bankId = bankId;


			let suggestedBank = this.bankTypes.filter((b) => b.isSameIban(event.AccountNumber))[0] as BankType | null;
			if (this.selectedBank && !this.selectedBank.isSameIban(event.AccountNumber)) {
				let confirm = await this.$confirmBuilder().setClass("warning").setWarningTitle().setMessage(this.$ct("coda-wrong-account-number", {
					winfakt: this.selectedBank.Name + " - " + this.selectedBank.Iban,
					coda: (suggestedBank ? suggestedBank.Name + " - " : "") + event.AccountNumber
				})).setYesText(this.$ct("common.continue")).setNoText(this.$ct("common.cancel")).show();
				if (!confirm) {
					return;
				}
				if (suggestedBank) {
					event.Banks.map((b: Bank) => {
						if (!suggestedBank) return;
						if (b.TypeID == this.bankId) {
							b.TypeID = suggestedBank.ID;
						}
					});
					this.bankId = suggestedBank.ID;
					bankId = suggestedBank.ID;
				}
			}

			event.Banks.map((b: Bank) => {
				b.Type = this.bankTypes.filter((c) => c.ID == b.TypeID)[0];
			});

			let currentBalance = await BankService.getBalance(bankId);

			if (event.BeginBalance != currentBalance) {
				let confirm = await this.$confirmBuilder().setClass("warning").setWarningTitle().setMessage(this.$ct("coda-balance-does-not-match", {
					winfakt: printHumanFloat(currentBalance),
					coda: printHumanFloat(event.BeginBalance)
				})).setYesText(this.$ct("common.continue")).setNoText(this.$ct("common.cancel")).show();
				if (!confirm) {
					this.close();
					return;
				}
			}

			let fileUploadedBefore = await BankService.isStNrUsed(event.Banks[0].StNr, bankId);
			if (fileUploadedBefore) {
				let builder = this.$confirmBuilder().setClass("warning").setWarningTitle().setMessage(this.$ct("coda-file-already-imported"));
				builder.setYesText(this.$ct("common.continue")).setNoText(this.$ct("common.cancel"));
				let confirm = await builder.show();
				if (!confirm) {
					this.close();
					return;
				}
			}

			this.banks = event.Banks;
			this.step = 2;
		},
		async done() {
			let currentBalance = await BankService.getBalance(this.bankId);
			if (currentBalance.toFixed(2) != this.endBalance.toFixed(2)) {
				let text = this.$ct("coda-end-balance-and-current-balance-mismatch", {
					winfakt: currentBalance.toFixed(2),
					coda: this.endBalance.toFixed(2)
				});

				let builder = this.$confirmBuilder().setClass("warning").setWarningTitle().setMessage(text);
				builder.setYesText(this.$ct("common.continue")).setNoText(this.$ct("common.cancel"));
				let confirm = await builder.show();
				if (confirm) {
					this.$emit("refresh");
					this.close();
					return;
				}
				this.close();
			}else{
				this.$emit("close");
			}

		}
	},
	async mounted() {
		if (!this.hasModule) {
			let tier = AuthService.wfCompany.Tier;
			await UpgradeService.showUpgradeModal(tier == 1 ? 2 : 1);
		}
		this.bankTypes = BankService.getTypes().filter(b=>b.ShowOnCodaImport);
		if(this.bankTypes){
			this.bankId = this.bankTypes[0].ID;
		}
	},
	components: {
		AppCodaUpload,
		AppCodaPreview,
		AppMissingModuleModal
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
